const WORDS = ["Logic", "Legacy", "The New Golden Age", "Timeless Wealth"];

export const Marquee = () => {
  const row = [...WORDS, ...WORDS, ...WORDS];
  return (
    <section data-testid="marquee" className="relative border-y border-[#d8ab4e]/20 bg-[#0a0805] py-8 md:py-12 overflow-hidden">
      <div className="marquee">
        {row.map((w, i) => (
          <span key={i} className="flex items-center whitespace-nowrap">
            <span className="font-display italic text-5xl md:text-7xl gold-text px-8">{w}</span>
            <span className="text-[#d8ab4e]/50 text-4xl md:text-6xl">✦</span>
          </span>
        ))}
      </div>
    </section>
  );
};

export default Marquee;
